import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SponsorsRoutingModule } from './sponsors-routing.module';
import { FormsModule } from '@angular/forms';
import { SponsorsComponent } from './sponsors.component';
import { FooterModule } from '../shared/components/footer/footer.module';
import { HeaderModule } from '../shared/components/header/header.module';
import { NavigationModalModule } from '../shared/components/navigation-modal/navigation-modal.module';
import { SponsorApplicationModule } from './sponsor-application/sponsor-application.module';
import { SponsorsLoginModule } from './sponsors-login/sponsors-login.module';
import { SponsorsPageModule } from './sponsors-page/sponsors-page.module';
import { SponsorsRegisterModule } from './sponsors-register/sponsors-register.module';
import { SponsorsFiltersModule } from './sponsor-filters/sponsor-filters.module';
import { ViewSponsorModule } from './view-sponsor/view-sponsor.module';
import { ViewSponsorshipApplicationsComponent } from './view-sponsorship-applications/view-sponsorship-applications.component';


@NgModule({
  declarations: [
    SponsorsComponent,
    // ViewSponsorshipApplicationsComponent, 
  ],
  imports: [
    CommonModule,
    SponsorsRoutingModule, 
    FormsModule, 
    FooterModule, 
    HeaderModule, 
    NavigationModalModule, 
    SponsorApplicationModule, 
    SponsorsLoginModule, 
    SponsorsPageModule, 
    SponsorsRegisterModule, 
    SponsorsFiltersModule, 
    ViewSponsorModule,

  ], 
  exports: [
    SponsorsComponent
  ], 
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SponsorsModule { }
